import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper } from '@material-ui/core';
import FileBase from 'react-file-base64';
import { useDispatch, useSelector } from 'react-redux';
import { createPost, updatePost } from '../actions';

import useStyles from './styles';

const Form = ({ currentId, setCurrentId }) => {
    const classes = useStyles();
    const [postData, setPostData] = useState({
        title: '', message: '', creator: '', tags: '', selectedFile: ''
    })
    const dispatch = useDispatch();
    const post = useSelector(state => currentId ? state.posts.find((p) => p._id === currentId) : null)

    useEffect(() => {
        if (post) setPostData(post);
    }, [post])

    const handleSubmit = (e) => {
        e.preventDefault();

        if (currentId) {
            dispatch(updatePost(currentId, postData));

        } else {
            dispatch(createPost(postData));

        }
        clear();
    }

    const clear = () => {
        setCurrentId(null);
        setPostData({
            title: '', message: '', creator: '', tags: '', selectedFile: ''
        })
    }
    return (
        <Paper className={classes.paper}>
            <form
                autoComplete='off'
                noValidate
                onSubmit={handleSubmit}
                className={`${classes.root} ${classes.form}`}
            >
                <Typography varient='h6'>{`${currentId ? 'Editing' : 'Creating'} a moment`}</Typography>

                <TextField name='title'
                    varient='outlined'
                    label='Title'
                    fullWidth
                    value={postData.title}
                    onChange={(e) => setPostData({ ...postData, title: e.target.value })}
                />

                <TextField name='message'
                    varient='outlined'
                    label='Message'
                    fullWidth
                    value={postData.message}
                    onChange={(e) => setPostData({ ...postData, message: e.target.value })}
                />

                <TextField name='creator'
                    varient='outlined'
                    label='Creator'
                    fullWidth
                    value={postData.creator} onChange={(e) => setPostData({ ...postData, creator: e.target.value })}
                />

                <TextField name='tags'
                    varient='outlined'
                    label='Tags'
                    fullWidth
                    value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: (e.target.value).split(',') })}
                />

                <div className={classes.fileInput}>
                    <FileBase type='file' multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} />
                </div>
                <Button className={classes.buttonSubmit}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit" fullWidth
                >
                    Post
                    </Button>
                <Button className={classes.buttonSubmit}
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={clear}
                    fullWidth
                >
                    Clear
                    </Button>
            </form>
        </Paper>
    )
}

export default Form;